import { useMutation } from "@tanstack/react-query";
import {
  getBankingAuthAuthenticatePisp,
  type AuthenticationUrl,
  type BankEnvironment,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onError?: () => void;
};

type PISPAuthenticateVariables = {
  environment?: BankEnvironment;
  transactionPublicID?: string;
};

export const usePISPAuthenticate = ({ onError }: Props = {}) =>
  useMutation<AuthenticationUrl, Error, PISPAuthenticateVariables>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ environment, transactionPublicID }) =>
        getBankingAuthAuthenticatePisp(environment, transactionPublicID),
    ),
    onSuccess: ({ url }) => {
      window.location.href = url;
    },
    onError,
  });
